import React from 'react';
import {
  formatAnswerValue,
  getMatchOptions,
  normalizeLetter,
} from './examUtils';

const ExamQuestion = ({
  question,
  task,
  index,
  answers,
  submitted,
  resultDetails,
  onAnswer,
}) => {
  const q = question;
  const detail = resultDetails[q.id];
  const isCorrect = detail?.is_correct;
  const userVal = answers[q.id];
  const correctVal = detail?.correct_answer;

  const btnClass = (selected, isCorrectOption, isWrongSelection, showCorrectHint) => {
    let c = 'exam-answer-btn';
    if (submitted) {
      if (isWrongSelection) c += ' is-wrong';
      else if (isCorrectOption && selected) c += ' is-correct';
      else if (showCorrectHint) c += ' is-correct-answer';
    } else if (selected) c += ' is-selected';
    return c;
  };

  const mcClass = (selected, isCorrectOption, isWrongSelection) => {
    let c = 'exam-mc-option';
    if (submitted) {
      if (isWrongSelection) c += ' is-wrong';
      else if (isCorrectOption && selected) c += ' is-correct';
    } else if (selected) c += ' is-selected';
    return c;
  };

  const label = q.question || q.statement;

  return (
    <div className="exam-question-block mb-3">
      <div className={q.type === 'truefalse' || q.options ? '' : 'exam-question-row'}>
        <div className="mb-2">
          <span className="exam-question-num">{index}.</span>
          {label}
        </div>

        {q.type === 'truefalse' && (
          <div className="exam-tf-group">
            {[true, false].map((val) => {
              const selected = answers[q.id] === val;
              const text = val ? 'Richtig' : 'Falsch';
              const isWrongSelection = submitted && selected && !isCorrect;
              const isCorrectOption = submitted && val === correctVal;
              let cls = 'exam-tf-btn';
              if (submitted) {
                if (isWrongSelection) cls += ' is-wrong';
                else if (isCorrectOption && selected) cls += ' is-correct';
                else if (isCorrectOption) cls += ' is-correct-answer';
              } else if (selected) cls += ' is-selected';
              return (
                <button
                  key={String(val)}
                  type="button"
                  disabled={submitted}
                  onClick={() => onAnswer(q.id, val)}
                  className={cls}
                >
                  {text}
                </button>
              );
            })}
          </div>
        )}

        {(q.type === 'person_match' || q.type === 'match' || q.type === 'headline_match' || q.type === 'heading_match' || q.type === 'speaker_match') && (
          <div className="exam-answer-group">
            {getMatchOptions(task, q).map((opt) => {
              const letter = opt.label || opt.id;
              const selected = normalizeLetter(answers[q.id]) === normalizeLetter(letter);
              const isWrongSelection = submitted && selected && !isCorrect;
              const isCorrectOption = submitted && normalizeLetter(letter) === normalizeLetter(correctVal);
              return (
                <button
                  key={opt.id}
                  type="button"
                  disabled={submitted}
                  onClick={() => onAnswer(q.id, letter)}
                  className={btnClass(selected, isCorrectOption && selected, isWrongSelection, submitted && isCorrectOption && !selected)}
                  title={opt.name || opt.author || opt.text}
                >
                  {(letter || '').toUpperCase()}
                </button>
              );
            })}
          </div>
        )}

        {!q.type && q.options && (
          <div className="mt-2">
            {q.options.map((opt, oi) => {
              const selected = answers[q.id] === oi;
              const isWrongSelection = submitted && selected && !isCorrect;
              const isCorrectOption = submitted && oi === correctVal;
              let extra = '';
              if (submitted && isCorrectOption && !selected) extra = ' ring-2 ring-green-600';
              return (
                <button
                  key={oi}
                  type="button"
                  disabled={submitted}
                  onClick={() => onAnswer(q.id, oi)}
                  className={`${mcClass(selected, isCorrectOption && selected, isWrongSelection)}${extra}`}
                >
                  <span className="exam-mc-letter">{String.fromCharCode(97 + oi)})</span>
                  <span>{opt}</span>
                </button>
              );
            })}
          </div>
        )}
      </div>

      {submitted && !isCorrect && (
        <p className="text-[11px] mt-1.5 text-red-800 font-sans">
          <strong>Ihre Antwort:</strong> {formatAnswerValue(q, userVal)}
          {' · '}
          <strong>Richtig:</strong> {formatAnswerValue(q, correctVal)}
        </p>
      )}
    </div>
  );
};

export default ExamQuestion;
